/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-shadow */
/* eslint-disable radix */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
const helpers = {};


/**
 * Returns a vue-fire config object for use in the view
 * @return {obj}
 */
helpers.getFirebaseObject = db => ({
  speakers: {
    source: db.ref('speakers'),
    asObject: false,
  },
  options: {
    source: db.ref('options'),
    asObject: true,
  },
  days: {
    source: db.ref('days'),
    asObject: false,
  },
});


/**
 * Retrieve the timezone str (EST, PST, etc.) based on the UTC offset int
 *
 * Currently only supports US timezones
 *
 * @param  {int} offset
 * @return {str}
 */
helpers.getTimezoneStr = (offset) => {
  const timezones = {
    '-4': 'EDT',
    '-5': 'EST',
    '-6': 'MT',
    '-7': 'PDT',
    '-8': 'PST',
    '-9': 'AKST',
    '-10': 'HAST',
  };
  return timezones[String(offset)];
};


/** Filter the firebase speakers object based on the provided year */
helpers.filterSpeakersByYear = (speakers, year) => {
  if (!speakers || !year) return;

  const rtn = [];

  speakers.forEach((data, index) => {
    if (data.presentations && year in data.presentations) {
      rtn[index] = {
        name: data.name,
        title: data.title,
        headshot: data.headshot,
        bio: data.bio,
        contact: data.contact,
        presentations: data.presentations[year],
      };
    }
  });
  return rtn;
};


/**
 * Get list of all liveblog entries for current year from speakers
 * object
 *
 * @param  {object} speakers
 * @return {array}  liveblog entries
 */
helpers.getLiveBlogEntries = (speakers, options) => {
  if (!speakers) return;
  const presentations = helpers.getPresentationsByDay(speakers, options);
  const entries = [];

  presentations.forEach((day) => {
    day.forEach((presentation) => {
      if ('liveblog' in presentation &&
        presentation.liveblog.length > 0) {
        presentation.liveblog.forEach((entry) => {
          entries.unshift(entry);
        });
      }
    });
  });
  return entries;
};


/** Create an identifiable hash based on a presentation obj */
// eslint-disable-next-line no-bitwise
helpers.getPresentationHash = presentation => presentation.title.split('').reduce((a, b) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a; }, 0);


/**
 * Find presentation object from provided list of presentation objects,
 * based on provided presentation hash
 *
 * @param  {[] of objects} presentations
 * @param  {str}           hash
 * @return {obj}
 */
helpers.getPresentationByHash = (presentations, hash) => {
  let presentation;

  presentations.forEach((day) => {
    day.forEach((p) => {
      if (hash === helpers.getPresentationHash(p)) {
        presentation = p;
      }
    });
  });
  return presentation;
};


/**
 * Return an array of arrays of presentation objects, based
 * on the provided Firebase speakers object.
 *
 * [
 *   [{Presentation}, {Presentation}], // Day 1
 *   [{Presentation}, {Presentation}], // Day 2
 * ]
 *
 * @param  {object} speakers [Firebase speakers object]
 * @return {array of arrays of objects}
 */
helpers.getPresentationsByDay = (speakers, options) => {
  // Create a sorted list of all the presentation objects
  let presentations = getPresentationsArray(speakers);
  const offset = helpers.getUTCOffset(options);
  presentations = sortPresentations(presentations, offset);

  // Build a new array of arrays (corresponding to the day) of
  // each presentation
  const rtn = [];
  rtn[0] = [];
  let previousPresentation;

  presentations.forEach((presentation) => {
    if (previousPresentation && 'date' in previousPresentation) {
      if (previousPresentation.date !== presentation.date) {
        rtn.push([]);
      }
    }
    rtn[rtn.length - 1].push(presentation);
    previousPresentation = presentation;
  });
  return rtn;


  /**
   * Returns an array of presentation objects based on the
   * provided firebase speakers object
   *
   * @param  {firebase speakers data} speakers
   * @return {array of presentation objects}
   */
  function getPresentationsArray(speakers) {
    if (!speakers) return;

    /**
     * Returns the index of the presentation based on its title
     * @param  {str}              title
     * @param  {array of objects} presentations
     * @return {int}              index
     */
    function findPresentationIndexByTitle(title, presentations) {
      let rtn = false;

      presentations.forEach((presentation, index) => {
        if (presentation.title === title) {
          rtn = index;
        }
      });
      return rtn;
    }

    // Filter the firebase speakers data based on the year
    const speakersForYear = helpers.filterSpeakersByYear(
      speakers, helpers.getYear(),
    );

    // Populate an array of presentation objects
    const presentations = [];

    speakersForYear.forEach((data) => {
      data.presentations.forEach((presentation) => {
        if (!presentation.start_time ||
          !presentation.end_time ||
          !presentation.date) return;

        const duplicatePresentation = findPresentationIndexByTitle(
          presentation.title,
          presentations,
        );

        if (duplicatePresentation !== false) {
          presentations[duplicatePresentation].speakers.push(data.name);
        } else {
          presentation.speakers = [data.name];

          // Normalize the dates to 10 character strings
          if (presentation.date.length === 9) {
            presentation.date = `0${presentation.date}`;
          }

          // Remove the timezone property
          delete presentation.timezone;

          presentations.push(presentation);
        }
      });
    });
    return presentations;
  }


  /** Sort an array of presentation objects based on time */
  function sortPresentations(presentations, offset) {
    const getTimestamp = helpers.getTimestamp;

    presentations.sort((a, b) => {
      const timestampA = getTimestamp(a.date, a.start_time, offset);
      const timestampB = getTimestamp(b.date, b.start_time, offset);
      return timestampA - timestampB;
    });
    return presentations;
  }
};

/**
 * Return the day event code
 */
helpers.getEventsByDay = (days, dayNum) => {
  const theDay = days.filter(day => day.day_number === dayNum);
  return theDay[0].day_event_id;
};

/**
 * Gets the year for the conference.
 *
 * Defaults to current year, but can be customized via a "year"
 * query param in the URL.
 *
 * /#/?year=2017 -> 2017 archives
 *
 * @return {int}
 */

helpers.getYear = () => 2021;

// helpers.getYear = () => {
//   let year = parseInt((new Date()).getFullYear());

//   if (getParameterByName('year') && !isNaN(getParameterByName('year'))) {
//     year = parseInt(getParameterByName('year'));
//   }
//   return year;

//   /**
//    * Get a query parameter from the URL
//    *
//    * @param  {str} name [name of parameter]
//    * @param  {str} url  [optional url]
//    * @return {str}      [query param value]
//    */
//   function getParameterByName(name, url) {
//     if (!url) url = window.location.href;
//     // eslint-disable-next-line no-useless-escape
//     name = name.replace(/[\[\]]/g, '\\$&');
//     const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
//     const results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2].replace(/\+/g, ' '));
//   }
// };


/**
 * Returns a Date() object based on the date string and time
 *
 * datestr format: '01/01/2018'
 * time format:    '11:00 AM'
 *
 * @param  {str} dateStr
 * @param  {str} time
 * @return {Date}
 */
helpers.getTimestamp = (dateStr, time, offset) => {
  if (!dateStr || !time || !offset) return;

  // Get date values
  const dateArr = dateStr.split('/');
  const year = parseInt(dateArr[2]);
  const month = parseInt(dateArr[0]) - 1;
  const day = parseInt(dateArr[1]);

  // Get time values
  const isPM = time.indexOf('PM') !== -1;
  const timeArr = (time.split(' ')[0]).split(':');
  const hours = parseInt(timeArr[0]);
  const minutes = parseInt(timeArr[1]);

  // Construct the date object
  let timestamp = new Date(Date.UTC(year, month, day, hours, minutes));
  timestamp.setHours(timestamp.getHours()); // subtract 1 for daylight savings
  // Subtract UTC offset
  const hour = 60 * 60 * 1000;
  timestamp -= offset * hour;

  // Convert hours to 24-hour time
  if (isPM && hours !== 12) timestamp += 12 * hour;
  return new Date(timestamp);
};


/**
 * Get UTC Offset based on options object
 *
 * @param  {object} options -> Firebase options data
 * @return {int}            -> UTC offset
 */
helpers.getUTCOffset = (options) => {
  if (options && 'live_timezone' in options) {
    return parseInt(options.live_timezone.replace('UTC', ''));
  }
};


/**
 * Get the Date() for today
 *
 * @return {Date}
 */
helpers.now = () => {
  const now = new Date();

  // TEST THE APP AT DIFFERENT DATES/TIMES BELOW
  // -------------------------------------------
  // now.setFullYear(2021);
  // now.setMonth(2);
  // now.setDate(25);
  // now.setHours(8);
  // now.setMinutes(15);

  return now;
};


/**
 * Get the status of the conference
 *
 * See more details in the declaration of the main() function below.
 */
helpers.getConferenceStatus = (presentations, offset) => {
  if (!presentations || !offset) return;

  const timestampsArr = timestampsArray(presentations, offset);
  const leeway = 30; /* minutes */
  const now = helpers.now();

  return main();


  /**
   * Returns the current presentation hash if the stream is live,
   * otherwise returns a string identifier.
   *
   * Identifiers:
   * - comingSoon (over five hours before conference)
   * - morning    (morning before daily stream begins)
   * - evening    (evening after stream ends)
   * - over       (conference is over)
   * - live       (stream is live, but no presentation is playing)
   *
   * @return {str} time identifier or presentation hash
   */
  function main() {
    // If the conference hasn't started, return either 'comingSoon'
    // or 'morning' depending on how soon it's gonna start

    if (now < beginningOfConference()) {
      const difference = beginningOfConference() - now;
      const fiveHours = 5 * 60 * 60 * 1000;

      if (difference > fiveHours) {
        return 'comingSoon';
      }
      return 'morning';
    }

    // If the conference has ended, return 'over'

    if (now > endOfConference()) {
      return 'over';
    }

    // Iterate through the timestamps array to determine whether to
    // return 'morning', 'evening', or the presentation hash

    for (const dayNum in timestampsArr) {
      const streamBeginsAt = addMinutesToDate(
        timestampsArr[dayNum][0][0],
        -leeway,
      );

      const streamEndsAt = addMinutesToDate(
        timestampsArr[dayNum][timestampsArr[dayNum].length - 1][1],
        leeway,
      );

      const isSameDay = now.getDate() === streamBeginsAt.getDate();
      const isMorning = isSameDay && now < streamBeginsAt;
      const isEvening = isSameDay && now > streamEndsAt;

      if (isMorning) return 'morning';
      if (isEvening) return 'evening';

      for (const presentationNum in timestampsArr[dayNum]) {
        const [start, end] = timestampsArr[dayNum][presentationNum];
        const currentlyPresenting = now > start && now < end;

        if (currentlyPresenting) {
          const presentation = presentations[dayNum][presentationNum];
          return helpers.getPresentationHash(presentation);
        }
      }
    }
    // Return 'live' by default
    return 'live';
  }


  /**
   * Return an array of arrays of Date() objects
   *
   * @param  {array of arrays of presentations} presentations
   * @return {array of arrays of Date() objects}
   */
  function timestampsArray(presentations, offset) {
    const timestamps = [];

    for (const day in presentations) {
      timestamps[day] = [];
      for (const p in presentations[day]) {
        const dateStr = presentations[day][p].date;
        const startTime = presentations[day][p].start_time;
        const endTime = presentations[day][p].end_time;
        const start = helpers.getTimestamp(dateStr, startTime, offset);
        const end = helpers.getTimestamp(dateStr, endTime, offset);
        timestamps[day][p] = [start, end];
      }
    }
    return timestamps;
  }


  /** Returns the last item of an array */
  function lastItem(arr) {
    return arr[arr.length - 1];
  }

  /**
   * Returns a new Date() object by adding minutes to date
   *
   * @param {Date} date
   * @param {int}  minutes
   */
  function addMinutesToDate(date, minutes) {
    return new Date(date.valueOf() + (minutes * 60 * 1000));
  }

  /** Returns the Date() object for when the stream begins */
  function beginningOfConference() {
    return addMinutesToDate(timestampsArr[0][0][0], -leeway);
  }

  /** Returns the Date() object for when the stream ends */
  function endOfConference() {
    const lastDay = lastItem(timestampsArr);
    const lastPresentation = lastItem(lastDay);

    return addMinutesToDate(lastPresentation[1], leeway);
  }
};


export default helpers;



// WEBPACK FOOTER //
// ./src/helpers.js